import { message } from "antd";
import FormHelpers from "../../../../helpers/FormHelpers";
import Helpers from '@Apis/helpers';

const ERROR_MESSAGES = {
  requiredField: (fieldName) => `Error in ${fieldName} field. Select/Enter a valid value then proceed.`,
};

const validateDocLevelFields = ({
  selectedSeller, tenantDepartmentId, dnDate, cfDebitNoteDoc, checkedRecipients, toRecipients, selectedGrn, purchaseAccount, user, dnNumber}) => {
  const errors = [];
  if(!dnNumber) {
    errors.push({
      name: "Debit Note Number",
      value: "",
      message: ERROR_MESSAGES.requiredField("Debit Note Number"),
    });
  }
  if (!selectedSeller) {
    errors.push({
      name: "Vendors",
      value: "",
      message: ERROR_MESSAGES.requiredField("Vendors"),
    });
  }
  if (!tenantDepartmentId) {
    errors.push({
      name: "Department",
      value: "",
      message: ERROR_MESSAGES.requiredField("Department"),
    });
  }
  if (!dnDate) {
    errors.push({
      name: "Debit Note Data",
      value: "",
      message: ERROR_MESSAGES.requiredField("Debit Note Date"),
    });
  }

  if (cfDebitNoteDoc) {
    cfDebitNoteDoc.forEach((field) => {
      if (field.isRequired && field?.isActive) {
        errors.push({
          name: field?.fieldName,
          value: field?.fieldValue,
          message: ERROR_MESSAGES.requiredField(field?.fieldName),
        });
      }
    });
  }

  if (checkedRecipients) {
    if (toRecipients?.length === 0) {
      errors.push({
        name: "Recipient Email",
        value: "",
        message: ERROR_MESSAGES.requiredField("Recipient Email"),
      })
    }
  }

  if (user?.tenant_info?.tally_configuration?.debit_note_account_selection === 'DOC_LEVEL') {
    errors.push({
      name: 'Purchase Account',
      value: purchaseAccount,
      message: ERROR_MESSAGES.requiredField('Purchase Account'),
    })
  }

  return errors;
};

const validateLineLevelFields = ({ data, debitNoteWithReturnedQyt, debitNoteWithoutLines, selectedGrn }) => {
  const errors = [];
  if (data) {
    data.forEach((item) => {
      if (!item?.product_sku_name) {
        errors.push({
          name: "Products",
          value: 0,
          message: !debitNoteWithoutLines ? "Error in Product. Select a product to continue." : "Error in Reason. Enter a valid Reason to coninue."
        });
      } else {
        if (!selectedGrn) {
          if ((Number(item?.quantity) <= 0 || (item?.quantity > Helpers.getValueTotalInObject(item?.product_batches?.filter((item) => item?.batch_in_use), 'available_qty'))) && !debitNoteWithoutLines) {
            errors.push({
              name: `Quantity in Product ${item?.product_sku_info?.internal_sku_code || ""}`,
              value: 0,
              message: ERROR_MESSAGES.requiredField(`Quantity for Product '${item?.product_sku_info?.internal_sku_code || ""}'`),
            })
          }
        } else {
          if ((Number(item?.quantity) <= 0 || (item?.quantity > Helpers.getValueTotalInObject(item?.product_batches?.filter((item) => (item?.batch_in_use)), 'consumed_qty'))) && !debitNoteWithoutLines){
            errors.push({
              name: `Quantity in Product ${item?.product_sku_info?.internal_sku_code || ""}`,
              value: 0,
              message: ERROR_MESSAGES.requiredField(`Quantity for Product '${item?.product_sku_info?.internal_sku_code || ""}'`),
            })
          }
        }

        // if ((Number(item?.returned_quantity) <= 0) && debitNoteWithReturnedQyt){
        //   errors.push({
        //     name: `Returned Quantity in Product ${item?.product_sku_info?.internal_sku_code || ""}`,
        //     value: 0,
        //     message: ERROR_MESSAGES.requiredField(`Quantity to be Returned for Product '${item?.product_sku_info?.internal_sku_code || ""}'`),
        //   })
        // }

        if(Number(item?.unitPrice) <= 0){
          errors.push({
            name: `Unit Price ${item?.product_sku_info?.internal_sku_code || ""}`,
            value: 0,
            message: !debitNoteWithoutLines ? ERROR_MESSAGES.requiredField(`Unit Price for Product '${item?.product_sku_info?.internal_sku_code || ""}'`) : ERROR_MESSAGES.requiredField("Unit Price for Debit Note Line")
          })
        }

        if(!item?.taxInfo){
          errors.push({
            name: `Tax in Product ${item?.product_sku_info?.internal_sku_code || ""}`,
            value: 0,
            message: !debitNoteWithoutLines ? ERROR_MESSAGES.requiredField(`Tax for Product '${item?.product_sku_info?.internal_sku_code || ""}'`) : ERROR_MESSAGES.requiredField("Tax for Debit Note Line"),
          })
        }
      }
    });
  }
  

  return errors;
};

const dnErrorList = (params) => {
  const docLevelErrors = validateDocLevelFields(params);
  const lineLevelErrors = validateLineLevelFields(params);
  
  return FormHelpers.errorChecker({ docLevelErrors, lineLevelErrors});
};

export default dnErrorList;